module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('span', [_c('i', [_vm._v("Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/fm01"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CONVERSATION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_c('i', [_vm._v("Part One")]), _vm._v(" PERAMA")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001"
    }
  }, [_vm._v("1 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE CHRISTENING")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002"
    }
  }, [_vm._v("2 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE BAY OF OLIVES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE MYRTLE FORESTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Part Two")]), _vm._v(" KONTOKALI")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE PYGMY JUNGLE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CUTTLEFISH AND CRABS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INTERLUDE FOR SPIRITS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE OLIVE MERRY-GO-ROUND")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OWLS AND ARISTOCRACY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Part Three")]), _vm._v(" CRISEDA")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HEDGEHOGS AND SEA-DOGS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE TALKING HEAD")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE ANGRY BARRELS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Epilogue")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MAIL")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/preview",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preview: "), _c('i', [_vm._v("The Garden of the Gods")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/bio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Biography of Gerald Durrell")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Message from Durrell Wildlife")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0